// extracted by mini-css-extract-plugin
export default {"container":"ReportActions_container__K2kMy"};